import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

type SortDirection = 'asc' | 'desc';

// Type helper to generate nested paths with dot notation
type NestedKeyOf<T> = T extends object
    ? {
          [K in keyof T & (string | number)]: K extends string
              ? T[K] extends object
                  ? K | `${K}.${NestedKeyOf<T[K]>}`
                  : K
              : never;
      }[keyof T & (string | number)]
    : never;

/**
 * Sort an array of objects by a specified field with case-insensitive comparison
 * @param data - Array of objects to sort
 * @param field - Field path to sort by (supports nested paths like 'employee.name')
 * @param direction - Sort direction ('asc' or 'desc'), defaults to 'asc'
 * @returns Sorted array
 */
export function sortByField<T extends object>(data: T[], field: NestedKeyOf<T>, direction: SortDirection = 'asc'): T[] {
    return orderBy(
        data,
        [
            (item) => {
                const value = get(item, field);
                return typeof value === 'string' ? value.toLowerCase() : value;
            },
        ],
        [direction]
    );
}
